export default __webpack_public_path__ + "images/8H.bf0387b.png";